import { generateGlobalRegionSeo } from '../dynamic-seo-generator';
import { applyLocationSeo } from './seo-strategy.helpers';
import { SeoStrategyFn } from './seo-strategy.type';

/**
 * SEO strategy for global region pages
 * Generates dynamic SEO from global region data in cache
 */
export const GlobalRegionSeoStrategy: SeoStrategyFn = (
  seoContent,
  $document,
  cacheContent,
  globalRegionId
) => {
  applyLocationSeo(
    globalRegionId,
    {
      seoKey: 'globalRegionPage',
      pageName: 'global',
      pathPrefix: '/buy-plan/plans/global',
      locationFinder: (cache, id) => {
        const globalRegion = cache.cache.globalRegions.find((gr) => gr._id === id);
        return globalRegion ? { name: globalRegion.name, data: globalRegion } : null;
      },
      seoGenerator: generateGlobalRegionSeo,
    },
    seoContent,
    $document,
    cacheContent
  );
};
